import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedReturnToCurrentPositionButton } from "@air/analytics/src/events/useTrackClickedReturnToCurrentPositionButton";
import { ArrowDown, ArrowUp } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import classNames from "classnames";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranscriptScrollInfoContext } from "~/providers/TranscriptScrollInfoProvider";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const ReturnToCurrentWordButton = /*#__PURE__*/ memo(()=>{
    const store = useAirStore();
    const [wordPosition, setWordPosition] = useState("on-screen");
    const { subscribeToWordPositionInfoChange, setScrollEnabled, returnToCurrentWord } = useTranscriptScrollInfoContext();
    const { trackClickedReturnToCurrentPositionButton } = useTrackClickedReturnToCurrentPositionButton();
    useEffect(()=>{
        const { unsubscribe } = subscribeToWordPositionInfoChange(setWordPosition);
        return ()=>{
            unsubscribe();
        };
    }, [
        subscribeToWordPositionInfoChange
    ]);
    const onReturnClick = useCallback(()=>{
        const clipId = centralizedClipIdSelector(store.getState());
        trackClickedReturnToCurrentPositionButton({
            clip_id: clipId
        });
        setScrollEnabled(true);
        returnToCurrentWord();
    }, [
        returnToCurrentWord,
        setScrollEnabled,
        store,
        trackClickedReturnToCurrentPositionButton
    ]);
    const ArrowPrefix = wordPosition === "above-screen" ? ArrowUp : ArrowDown;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("pointer-events-auto absolute bottom-6 left-1/2 z-1 flex max-w-48 -translate-x-1/2 shadow-popover", wordPosition === "on-screen" || wordPosition === "empty" ? "hidden" : ""),
        children: /*#__PURE__*/ _jsx(Button, {
            "data-testid": "RETURN_TO_CURRENT_WORD_BUTTON",
            appearance: "filled",
            color: "blue",
            size: "small",
            prefix: /*#__PURE__*/ _jsx(ArrowPrefix, {
                className: "size-4"
            }),
            onClick: onReturnClick,
            className: "whitespace-normal text-center",
            children: "Resync to audio"
        })
    });
});
ReturnToCurrentWordButton.displayName = "TranscriptScrollSwitch";
